<template>
  <v-container 
    fluid 
     :class="['container-full-bg-gray', { 'supplier-list--mobile': isMobile }]"
    >
    <div>
      <MassiveChangesPopUp
        v-if="massiveDialog"
        :dialog="massiveDialog"
        :buttons-on-top="true"
        @close-popup="cancelMassiveChanges()"
        @save-massive-changes="doMassiveChanges()"
      >
        <template v-slot:inputs>
          <app-modal-row >
            <app-modal-col>
              <p class="black--text font-weight-light text-center massive-info mb-6" >
                Seleccione el campo sobre el que quiere realizar el cambio masivo marcando el <v-checkbox hide-details class="ma-0 pa-0 check-info" readonly style="display: inline-block;"/> y seleccione o deje en blanco el valor que desee que tengan dichas facturas según el cambio a realizar.
              </p>
            </app-modal-col>
          </app-modal-row>
          <app-modal-row>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.expens_accounts"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="account"
                    :label="cru_label_expens_accounts" 
                    v-model="cru_expens_accounts"
                    :error="Boolean(cru_error_expens_accounts)"
                    :disabled="!isEnabled.expens_accounts"
                  ></app-doc-text-field>
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>
            </app-modal-col>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1"></app-modal-col>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.retention_type"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    autocomplete="off"
                    :label="cru_label_retention_type"  
                    v-model="cru_retention_type"
                    :items="get_retention_types"
                    :readonly="false"  
                    class="autocomplete-input pa-0"
                    :disabled="!isEnabled.retention_type"
                  />
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
          </app-modal-row>

          <app-modal-row v-if="got_feature('feature_payment_move') && got_feature('feature_automatic_account_massive_changes')">
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.automatic_payment_account"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    outlined
                    v-model="cru_automatic_payment_account"
                    autocomplete="off"
                    :label="cru_label_automatic_payment_account" 
                    :items="automaticPaymentAccountTypes"
                    :disabled="!isEnabled.automatic_payment_account"
                  />
                </app-modal-col>
              </app-modal-row>            
            </app-modal-col>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1"></app-modal-col>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.payment_account"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="account"
                    :label="cru_label_payment_account" 
                    v-model="cru_payment_account"
                    :error="Boolean(cru_error_payment_account)"
                    :disabled="!isEnabled.payment_account"
                  ></app-doc-text-field>
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>
            </app-modal-col>
          </app-modal-row>

          <app-modal-row v-if="showMassiveChangeSuplidoAccount()">
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.suplido_account"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="account"
                    :label="cru_label_suplido_account" 
                    v-model="cru_suplido_account"
                    :error="Boolean(cru_error_suplido_account)"
                    :disabled="!isEnabled.suplido_account"
                  ></app-doc-text-field>
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
          </app-modal-row>

          <app-modal-row v-if="got_feature('feature_default_actividad_project_channel_in_massive_changes')">
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.default_actividad"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    v-if="got_feature('feature_actividad_selector') && activities.length > 0"
                    :label="cru_label_default_actividad"
                    v-model="cru_default_actividad"
                    :items="activities"
                    item-value="code"
                    item-text="name"
                    :clearable="true"
                    :error="Boolean(cru_error_default_actividad)"
                    :disabled="!isEnabled.default_actividad"
                  />
                  <app-doc-text-field
                    v-else
                    kind="string"
                    v-model="cru_default_actividad"
                    :label="cru_label_default_actividad"
                    :error="Boolean(cru_error_default_actividad)"
                    :disabled="!isEnabled.default_actividad"
                  />
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>
            </app-modal-col>
            <app-modal-col cols="6" v-if="got_feature('feature_default_project_channel_in_third') && feature_document_projects && hasMasterPermission('project')">
              <app-modal-row>
                <app-modal-col cols="1"></app-modal-col>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.default_project"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    :label="cru_label_default_project"
                    v-model="cru_default_project"
                    :items="projects"
                    item-value="id"
                    item-text="name"
                    :clearable="true"
                    :error="Boolean(cru_error_default_project)"
                    :disabled="!isEnabled.default_project"
                  ></app-autocomplete>
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
            <app-modal-col cols="6" v-if="got_feature('feature_default_project_channel_in_third') && got_feature('feature_channel') && hasMasterPermission('channel')">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.default_channel"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    :label="cru_label_default_channel"
                    v-model="cru_default_channel"
                    :items="channels"
                    item-value="channel_id"
                    item-text="name"
                    :clearable="true"
                    :error="Boolean(cru_error_default_channel)"
                    :disabled="!isEnabled.default_channel"
                  ></app-autocomplete>
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>

            <app-modal-col cols="6" v-if="got_feature('feature_default_section_in_third') && got_feature('feature_sections') && hasMasterPermission('section')">
              <app-modal-row>
                <app-modal-col cols="1"></app-modal-col>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.default_section"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    :label="cru_label_default_section"
                    v-model="cru_default_section"
                    :items="sections"
                    item-value="section_id"
                    item-text="name"
                    :clearable="true"
                    :error="Boolean(cru_error_default_section)"
                    :disabled="!isEnabled.default_section"
                  ></app-autocomplete>
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
          </app-modal-row>

          <app-modal-row>
          <app-modal-col cols="6" v-if="got_feature('feature_default_delegation_in_third') && got_feature('feature_delegations') && hasMasterPermission('delegation')">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_delegation"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  :label="cru_label_default_delegation"
                  v-model="cru_default_delegation"
                  :items="delegations"
                  item-value="delegation_id"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_delegation)"
                  :disabled="!isEnabled.default_delegation"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>

          <app-modal-col cols="6" v-if="got_feature('feature_default_department_in_third') && got_feature('feature_departments') && hasMasterPermission('department')">
            <app-modal-row>
              <app-modal-col cols="1"></app-modal-col>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_department"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  :label="cru_label_default_department"
                  v-model="cru_default_department"
                  :items="departments"
                  item-value="department_id"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_department)"
                  :disabled="!isEnabled.default_department"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
        </app-modal-row>
          
          <app-modal-row>  
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.zip_code"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="text"
                    :label="cru_label_zip_code" 
                    v-model="cru_zip_code"
                    :error="Boolean(cru_error_zip_code)"
                    :disabled="!isEnabled.zip_code"
                  ></app-doc-text-field>
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>
            </app-modal-col>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1"></app-modal-col>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.city"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="text"
                    :label="cru_label_city" 
                    v-model="cru_city"
                    :error="Boolean(cru_error_city)"
                    :disabled="!isEnabled.city"
                  ></app-doc-text-field>
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
          </app-modal-row>
          <app-modal-row>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.province"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="text"
                    :label="cru_label_province"  
                    v-model="cru_province"
                    :error="Boolean(cru_error_province)"
                    :disabled="!isEnabled.province"
                  ></app-doc-text-field>
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>
            </app-modal-col>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1"></app-modal-col>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.country"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    autocomplete="off"
                    :label="cru_label_country" 
                    v-model="cru_country"
                    :items="autocompleteCountryItems"
                    class="autocomplete-input pa-0"
                    :hide-details="true"
                    :disabled="!isEnabled.country"
                  />
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
          </app-modal-row>
          <app-modal-row>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.type"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    autocomplete="off"
                    :label="cru_label_type"  
                    v-model="cru_type"
                    :items="thirdTypeTypes"
                    :readonly="false"  
                    class="autocomplete-input pa-0"
                    :disabled="!isEnabled.type"
                  />
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1"/>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.notes"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="text"
                    :label="cru_label_notes" 
                    v-model="cru_notes"
                    :error="Boolean(cru_error_notes)"
                    :disabled="!isEnabled.notes"
                  ></app-doc-text-field>
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>
            </app-modal-col>
            <app-modal-col cols="6">
            </app-modal-col>
          </app-modal-row>

          <v-divider />

          <app-modal-row justify="space-around">
            <app-modal-col cols="3">
              <v-checkbox
                v-model="isEnabled.types"
                label="Posición fiscal"
                :hide-details="true"
                class="pa-0"
              ></v-checkbox>

              <v-radio-group v-model="selectedFiscal" :key="selectedFiscal" :disabled="!isEnabled.types">
                <div @click="toggleFiscal">
                  <v-radio value="inversion_sujeto_pasivo_iva" :label="cru_label_inversion_sujeto_pasivo_iva"  />
                </div>
                <div @click="toggleFiscal">
                  <v-radio value="inversion_sujeto_pasivo_igic" :label="cru_label_inversion_sujeto_pasivo_igic" />
                </div>
                <div @click="toggleFiscal">
                  <v-radio
                    value="no_sujeta"
                    :label="cru_label_no_sujeta"
                    :disabled="!isEnabled.types || !(feature_no_sujeta || got_feature('feature_exenta_no_sujeta'))"
                  />
                </div>
                <div @click="toggleFiscal">
                  <v-radio
                    value="dry_0_percent"
                    :label="cru_label_dry_0_percent"
                    :disabled="!isEnabled.types || !(feature_no_sujeta || got_feature('feature_exenta_no_sujeta'))"
                  />
                </div>
                <div @click="toggleFiscal">
                  <v-radio value="intracomunitario" :label="cru_label_intracomunitario" />
                </div>
<!--                <div @click="toggleFiscal">-->
<!--                  <v-radio value="extracomunitario" :label="cru_label_extracomunitario" />-->
<!--                </div>-->
                <div 
                  v-if="got_feature('feature_supplier_comerciante_minorista') && currentCompany.tax_type == 'igic'" 
                  @click="toggleFiscal"
                >
                  <v-radio value='is_comerciante_minorista' :label='cru_label_is_comerciante_minorista' />
                </div>

              </v-radio-group>

              <app-modal-col cols="12" >
                <app-autocomplete
                  autocomplete="off" 
                  v-if="selectedFiscal === 'inversion_sujeto_pasivo_iva' && isEnabled.types"
                  :label="cru_label_percent" 
                  v-model="cru_inversion_sujeto_pasivo_iva_percent"
                  :items="[{text:'IVA 21%',value:'vat_21'},{text:'IVA 12%',value:'vat_12'},{text:'IVA 10.5%',value:'vat_10_5'},
                  {text:'IVA 10%',value:'vat_10'},{text:'IVA 5%',value:'vat_5'},{text:'IVA 4%',value:'vat_4'}]"
                  :readonly="false"  
                  class="autocomplete-input pa-0 mt-5"
                  :hide-details="true"
                  @change="areParamsChanged=true"
                />
                <app-autocomplete
                  autocomplete="off" 
                  v-if="selectedFiscal === 'inversion_sujeto_pasivo_igic' && isEnabled.types"
                  :label="cru_label_percent"  
                  v-model="cru_inversion_sujeto_pasivo_igic_percent"
                  :items="[{text:'IGIC 20%',value:'igic_20'}, {text:'IGIC 15%',value:'igic_15'},{text:'IGIC 9.5%',value:'igic_95'},{text:'IGIC 7%',value:'igic_7'},{text:'IGIC 3%',value:'igic_3'},{text:'IGIC 1%',value:'igic_1'}]"
                  :readonly="false"  
                  class="autocomplete-input pa-0 mt-5"
                  :hide-details="true"
                  @change="areParamsChanged=true"
                />
                <app-autocomplete
                  autocomplete="off" 
                  v-if="selectedFiscal === 'intracomunitario' && isEnabled.types"
                  :label="cru_label_percent"  
                  v-model="cru_intracomunitario_percent"
                  :items="[{text:'IVA 21%',value:'vat_21'},{text:'IVA 12%',value:'vat_12'},{text:'IVA 10.5%',value:'vat_10_5'},
                  {text:'IVA 10%',value:'vat_10'},{text:'IVA 5%',value:'vat_5'},{text:'IVA 4%',value:'vat_4'},{text:'IVA 0%',value:'vat_0'},
                  {text:'IGIC 20%',value:'igic_20'},{text:'IGIC 15%',value:'igic_15'},{text:'IGIC 9.5%',value:'igic_95'},
                  {text:'IGIC 7%',value:'igic_7'},{text:'IGIC 3%',value:'igic_3'},{text:'IGIC 1%',value:'igic_1'},{text:'IGIC 0%',value:'igic_0'}]"
                  :readonly="false"  
                  class="autocomplete-input pa-0 mt-5"
                  :hide-details="true"
                  @change="areParamsChanged=true"
                />
                <app-autocomplete
                  autocomplete="off" 
                  v-if="selectedFiscal === 'extracomunitario' && isEnabled.types"
                  :label="cru_label_percent"  
                  v-model="cru_importaciones_percent"
                  :items="[{text:'IVA 21%',value:'vat_21'},{text:'IVA 12%',value:'vat_12'},{text:'IVA 10.5%',value:'vat_10_5'},
                  {text:'IVA 10%',value:'vat_10'},{text:'IVA 5%',value:'vat_5'},{text:'IVA 4%',value:'vat_4'},{text:'IVA 0%',value:'vat_0'},
                  {text:'IGIC 20%',value:'igic_20'},{text:'IGIC 15%',value:'igic_15'},{text:'IGIC 9.5%',value:'igic_95'},
                  {text:'IGIC 7%',value:'igic_7'},{text:'IGIC 3%',value:'igic_3'},{text:'IGIC 1%',value:'igic_1'},{text:'IGIC 0%',value:'igic_0'}]"
                  :readonly="false"  
                  class="autocomplete-input pa-0 mt-5"
                  :hide-details="true"
                  @change="areParamsChanged=true"
                />
                <app-autocomplete
                  autocomplete="off" 
                  v-if="selectedFiscal === 'is_comerciante_minorista' && isEnabled.types"
                  :label="cru_label_percent"  
                  v-model="cru_is_comerciante_minorista_percent"
                  :items="[{text:'IGIC 1%',value:'igic_1'},{text:'IGIC 3%',value:'igic_3'},{text:'IGIC 7%',value:'igic_7'},{text:'IGIC 9.5%',value:'igic_95'},{text:'IGIC 15%',value:'igic_15'},{text:'IGIC 20%',value:'igic_20'}]"
                  :readonly="false"  
                  class="autocomplete-input pa-0 mt-5"
                  :hide-details="true"
                  @change="areParamsChanged=true"
                />
              </app-modal-col>

              <app-modal-col v-if="(selectedFiscal === 'intracomunitario' && feature_intra_type) || (selectedFiscal === 'extracomunitario' && (feature_extra_type || feature_extracomunitario_type))" class="mt-5" cols="12">
                <app-autocomplete
                  autocomplete="off"
                  :label="cru_label_intracomunitario_type"
                  v-model="cru_intracomunitario_type"
                  :items="[{text: 'Bienes', value: 'bienes'}, {text: 'Servicios', value: 'servicios'}]"
                  :readonly="false"
                  class="autocomplete-input pa-0 "
                  :hide-details="true"
                  @change="areParamsChanged=true"
                  :background-color="Boolean(cru_error_intracomunitario_type)?'#ff9898':'#ffffff'"
                  :disabled="!isEnabled.types"
                />
              </app-modal-col>
            </app-modal-col>
            <v-divider inset vertical />
            <app-modal-col cols="3" >
              <app-modal-row>
                <app-modal-col cols="auto">
                  <v-checkbox
                    v-model="isEnabled.criterio_de_caja"
                    :hide-details="true"
                    :disabled="!got_feature('feature_criterio_de_caja')"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col>
                  <v-radio-group class="pa-0" v-model="selectedCriterioCaja" :key="selectedCriterioCaja" hide-details>
                    <div @click="toggleCriterioCaja">
                      <v-radio
                          :label="cru_label_criterio_de_caja"
                          :disabled="!isEnabled.criterio_de_caja || !got_feature('feature_criterio_de_caja')"
                          :value="true"
                      />
                    </div>
                  </v-radio-group>
<!--                  <v-checkbox-->
<!--                    class="pa-0"-->
<!--                    v-model="cru_criterio_de_caja"-->
<!--                    :label="cru_label_criterio_de_caja"-->
<!--                    :disabled="!isEnabled.criterio_de_caja || !got_feature('feature_criterio_de_caja')"-->
<!--                  ></v-checkbox>-->
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>
              <app-modal-row>
                <app-modal-col cols="auto">
                  <v-checkbox
                    v-model="isEnabled.prorate"
                    :disabled="!currentCompany.prorate"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col>
<!--                  <v-checkbox  -->
<!--                    autocomplete="off"-->
<!--                    :label="cru_label_prorate"-->
<!--                    v-model="cru_prorate"-->
<!--                    :readonly="false"-->
<!--                    class="pa-0"-->
<!--                    :hide-details="true"-->
<!--                    :disabled="!isEnabled.prorate || !currentCompany.prorate"-->
<!--                  ></v-checkbox>-->
                  <v-radio-group class="pa-0" v-model="selectedProrate" :key="selectedProrate" hide-details>
                    <div @click="toggleProrate">
                      <v-radio
                          :label="cru_label_prorate"
                          :disabled="!isEnabled.prorate || !currentCompany.prorate"
                          :value="true"
                      />
                    </div>
                  </v-radio-group>
                </app-modal-col>
                <app-modal-col cols="1"></app-modal-col>
              </app-modal-row>

              <app-modal-row v-if="got_feature('feature_supplier_comerciante_minorista') && currentCompany.tax_type == 'igic'">
                <app-modal-col cols="auto">
                  <v-checkbox
                    v-model="isEnabled.is_comerciante_minorista"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col>
                  <v-radio-group class="pa-0" v-model="selectedIsComercianteMinorista" :key="selectedIsComercianteMinorista" hide-details>
                    <div @click="toggleIsComercianteMinorista">
                      <v-radio
                          :label="cru_label_is_comerciante_minorista"
                          :disabled="!isEnabled.is_comerciante_minorista"
                          :value="true"
                      />
                    </div>
                  </v-radio-group>
                </app-modal-col>
              </app-modal-row>

            </app-modal-col>
            <v-divider inset vertical />
            <app-modal-col cols="3">
              <v-checkbox
                v-model="isEnabled.are_deducible"
                label="Deducibilidad"
                :hide-details="true"
                class="pa-0"
              ></v-checkbox>

              <v-radio-group v-model="selectedIvaCheck" :mandatory="false" @change="areIvaChecksChanged=true" :disabled="!isEnabled.are_deducible">
                  <div @click="toggleIvaCheck">
                      <v-radio value="iva_igic_no_deducible" :label="cru_label_iva_igic_no_deducible" />
                  </div>
                  <div @click="toggleIvaCheck" v-if="feature_gasto_iva_parcial">
                      <v-radio value="gasto_iva_parcial" :label="cru_label_gasto_iva_parcial" />
                  </div>
                  <div @click="toggleIvaCheck" v-if="feature_iva_deducible_parcialmente">
                      <v-radio value="iva_parcial" :label="cru_label_iva_parcial" />
                  </div>
              </v-radio-group>

              <app-doc-text-field
                v-if="selectedIvaCheck=='gasto_iva_parcial' || selectedIvaCheck=='iva_parcial'"
                kind="number"
                :label="cru_label_gasto_iva_percent"
                v-model="cru_gasto_iva_percent"
                :error="Boolean(cru_error_gasto_iva_percent)"
                @change="areIvaChecksChanged=true"
                :disabled="!isEnabled.are_deducible"
              ></app-doc-text-field>
              <app-doc-text-field
                style="margin-top:15px"
                v-if="got_feature('feature_exc_expense_account') && selectedIvaCheck=='iva_parcial'"
                kind="account"
                v-model="cru_exc_expense_account"
                :label="cru_label_exc_expense_account"
                :error="Boolean(cru_error_exc_expense_account)"
                @change="areIvaChecksChanged=true"
                :disabled="!isEnabled.are_deducible"
              />
              <v-checkbox
                  v-if="selectedIvaCheck=='iva_igic_no_deducible' && got_feature('feature_comerciante_minorista') && currentCompany.companydb_type.params && ((!currentCompany.companydb_type.params.hasOwnProperty('hide')) || (currentCompany.companydb_type.params.hide && !currentCompany.companydb_type.params.hide.includes('comerciante_minorista')))"
                  autocomplete="off"
                  :label="cru_label_register_iva_igic_0"
                  v-model="cru_register_iva_igic_0"
                  :readonly="false"
                  class="pa-0 ma-0 my-2"
                  :hide-details="true"
              ></v-checkbox>
            </app-modal-col>
          </app-modal-row>
        </template>
      </MassiveChangesPopUp>

      <ListObject
        :objectType="objectType"
        :url="url"
        :selectRow="selectRow"
        :headers="supplierdbListHeadersUser"
        :create="create"
        :canCreate="!got_feature('feature_not_create_thirds_and_masters')"
        :filtersData="filtersData"
        :deleteMsg="deleteMsg"
        :errorMsg="errorMsg"
        :rowsNumber="rowsPerPage"
        @rowsPerPage="setRowsNumber"

        :generateFilters="genFilters"
        :cleanFilters="cleFilters"
        :refreshData="refresh"
        :filters="currentFilters"
        :selectionableRows="true"

        @item-selected="send_filters = false"

        @selected-action="selectedAction"
        @job-done="jobDone"
        :actions="getActions"
        :loadingAction="loadingAction"
        :disabledActions="selected.length==0"
      >
      <!-- :selectedAction="selected_action" -->

        <template v-slot:header-prefix>
          <v-btn
            v-if="currentCompany"
            icon
            @click="backToDocuments()"
            color="primary"
          >
            <AppIcon :src="require('@/assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
          </v-btn>
        </template>
        <template v-slot:actions>
          <!-- <action-selector 
            store="cru"
            :actions="getActions" 
            :loading="loadingAction"
            :disabled="selected.length==0"
            @do-action="doAction"
            @job-done="jobDone"
            @selected-action="selectedAction"
          ></action-selector> -->
        </template>

        <template v-slot:select_all>
          <v-checkbox
            v-if="show_select_all"
            :label="'Aplicar en los ' + length_items + ' clientes'"
            class="ma-0 pt-2 pl-4 pb-2 pr-0" 
            v-model="send_filters"
            hide-details
          ></v-checkbox>
        </template>
        
        <template v-slot:filters>
          <v-row>
            <v-col cols="12">
              <div>

                <v-text-field 
                  autocomplete="off" 
                  :label="sup_filters_supplier__name__icontains.label" 
                  v-model="sup_filters_supplier__name__icontains_value"
                  v-on:keyup.enter="genFilters"
                ></v-text-field>
                <v-text-field 
                  autocomplete="off" 
                  :label="sup_filters_supplier__nif__icontains.label" 
                  v-model="sup_filters_supplier__nif__icontains_value"
                  v-on:keyup.enter="genFilters"
                ></v-text-field>
                <v-text-field 
                  autocomplete="off" 
                  :label="sup_filters_expens_account__icontains.label" 
                  v-model="sup_filters_expens_account__icontains_value"
                  v-on:keyup.enter="genFilters"
                ></v-text-field>
                <v-text-field 
                  autocomplete="off" 
                  :label="sup_filters_credit_account__icontains.label" 
                  v-model="sup_filters_credit_account__icontains_value"
                  v-on:keyup.enter="genFilters"
                ></v-text-field>

              </div>
            </v-col>
          </v-row>
        </template>
      
      </ListObject>
    </div>
    
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ListObject from '../components/ListObject.vue';
import ActionSelector from '../components/ActionSelector.vue';
import AppDocTextField from "@/components/layout/AppDocTextField.vue";
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import MessagePopup from '../components/MessagePopup.vue';
import DocTextField from "../components/DocTextField.vue";
import MassiveChangesPopUp from '../components/MassiveChangesPopUp.vue';
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix, vuexPrefix2 } from "../store/vuex_utils";
import { jobs } from '../api/jobs.js';
import { isMobile } from 'filestack-js';
export default {
  components: {
    ListObject,
    ActionSelector,
    AppDocTextField,
    AppAutocomplete,
    AppModalCol,
    AppModalContainer,
    AppModalRow,
    MessagePopup,
    DocTextField,
    MassiveChangesPopUp,
  },
  props: {
    companydb_id: {
      type: [String, Number],
    },
  },
  data() {
    return {
      objectType: "Proveedores",
      url: "suppliers/",
      create: "create-supplier",
      update: "supplier-update",
      filtersData: [
        {
          'name': 'supplier__name__icontains', 
          'label': 'Nombre de proveedor'
        },
        {
          'name': 'supplier__nif__icontains', 
          'label': 'CIF de proveedor'
        },
        {
          'name': 'expens_account__icontains', 
          'label': 'Cuenta de Gastos'
        },
        {
          'name': 'credit_account__icontains', 
          'label': 'Cuenta de Proveedor'
        },
      ],
      deleteMsg: "Se borrará este proveedor. ¿Está seguro?",
      errorMsg: "No fué posible borrar este proveedor.",

      ids: [],
      loadingAction: false,
      documentName: '',
      documentFormat: '',
      message: '',
      show_message: false,
      message_actions: [{ 'action_text': 'OK', 'emit': 'close-message', 'prin': true }],

      massiveDialog: false,
      isEnabled: {
        'expens_accounts': false,
        'retention_type': false,
        // '': false,
        'types': false,
        'are_deducible': false,
        'default_actividad': false, 
        'default_project': false, 
        'default_channel': false,
        'default_section': false,
        'default_delegation': false,
        'default_department': false,
        'zip_code': false,
        'city': false,
        'province': false,
        'country': false,
        'notes': false,
        'review': false,
        'prorate': false,
        'criterio_de_caja': false,
        'is_comerciante_minorista': false,
        'suplido_account': false,
        'type': false,
      },
      selected_action: '',
      send_filters: false,
      lastSelectedIvaCheck: undefined,
      selectedFiscal: '',
      selectedCriterioCaja: '',
      selectedProrate: '',
      selectedIsComercianteMinorista: '',
    }
  },
  computed: {
    ...mapState(['currentCompany',]),
    ...mapGetters({
      rowsPerPage: "supplierRowsPerPage",
      getCountryByCode: 'countries/getCountryByCode', 
      getCountries: 'countries/getCountries',
      get_retention_types: 'get_retention_types',
      got_feature:'got_feature',
      supplierdbListHeadersUser: 'documents/supplierdbListHeadersUser',
      isMobile: 'is_mobile',
    }),

    ...mapFields({
      page: 'objectListOptions.page',
      selected: 'objectListSelected',
      downloadJobState: 'downloadJobState',
      asyncJobId: 'asyncJobId',
      items: 'objectListItems',
      length_items: 'objectListItemsLength',
      activities: 'activities',
      projects: 'projects',
      channels: 'channels',
      sections: 'sections',
      delegations: 'delegations',
      departments: 'departments',
      automaticPaymentAccountTypes: 'automaticPaymentAccountTypes',
      thirdTypeTypes: 'thirdTypeTypes',
    }),
    ...mapFields('cru', {
      actualScreen: 'actualScreen',
      currentFilters: 'currentFilters.supplierListValues',
      actions: 'actions.supplierListValues',
    }), 
    ...mapFields('cru',['selectedIvaCheck']),
    ...mapFields('cru',vuexPrefix('sup_filters_',['supplier__name__icontains', 'supplier__nif__icontains', 'expens_account__icontains', 'credit_account__icontains'],'filtersData.supplierListValues.')),
    ...mapFields('cru',vuexPrefix2('sup_filters_', ['value'], 'filtersData.supplierListValues.', ['supplier__name__icontains', 'supplier__nif__icontains', 'expens_account__icontains', 'credit_account__icontains'])),

    ...mapFields('cru',vuexPrefix('cru_',[
      'expens_accounts', 'retention_type', 'fiscal_location', 'inversion_sujeto_pasivo_iva_percent', 'inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic_percent', 'inversion_sujeto_pasivo_igic',
      'iva_igic_no_deducible', 'intracomunitario_percent', 'intracomunitario', 'importaciones_percent', 'extracomunitario', 'zip_code', 'city', 'province', 'country', 'notes', 
      'review', 'payment_account', 'automatic_payment_account', 'automatic_payment_account_choices', 'charge_account', 'automatic_charge_account', 'no_sujeta', 'dry_0_percent',
      'intracomunitario_type', 'gasto_iva_percent', 'prorate', 'exc_expense_account', 'criterio_de_caja', 'default_actividad', 'default_project', 
      'default_channel', 'is_comerciante_minorista', 'is_comerciante_minorista_percent', 'register_iva_igic_0', 'suplido_account', 'type', 'default_section',
      'default_delegation', 'default_department'
    ],'screenValues.supplierScreenValues.')),
    ...mapFields('cru',vuexPrefix('cru_error_',[
      'expens_accounts', 'retention_type', 'fiscal_location', 'inversion_sujeto_pasivo_iva_percent', 'inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic_percent', 'inversion_sujeto_pasivo_igic',
      'iva_igic_no_deducible', 'intracomunitario_percent', 'intracomunitario', 'importaciones_percent', 'extracomunitario', 'zip_code', 'city', 'province', 'country', 'notes', 
      'review', 'payment_account', 'automatic_payment_account', 'automatic_payment_account_choices', 'charge_account', 'automatic_charge_account', 'no_sujeta', 'dry_0_percent',
      'intracomunitario_type', 'gasto_iva_percent', 'exc_expense_account', 'default_actividad', 'default_project', 'default_channel', 'is_comerciante_minorista_percent', 'suplido_account', 
      'type', 'default_section', 'default_delegation', 'default_department'
    ],'screenErrors.supplierScreenValues.')),
    ...mapFields('cru', vuexPrefix('cru_errors_',['supplierScreenValues'],'screenErrors.')),
    ...mapFields('cru',vuexPrefix('cru_label_',[
      'expens_accounts', 'retention_type', 'fiscal_location', 'inversion_sujeto_pasivo_iva', 'percent', 'inversion_sujeto_pasivo_igic', 'iva_igic_no_deducible', 'intracomunitario', 
      'extracomunitario', 'zip_code', 'city', 'province', 'country', 'notes', 'review', 'automatic_payment_account', 'payment_account', 'no_sujeta', 'dry_0_percent',
      'intracomunitario_type', 'gasto_iva_parcial', 'iva_parcial', 'gasto_iva_percent', 'prorate', 'exc_expense_account', 'criterio_de_caja', 'default_actividad',
      'default_project', 'default_channel', 'is_comerciante_minorista', 'register_iva_igic_0', 'suplido_account', 'type', 'default_section', 'default_delegation', 'default_department'
    ], 'inputLabels.')),
    ...mapFields('me',vuexPrefix('',[
      'feature_no_sujeta', 'feature_intra_type', 'feature_extra_type', 'feature_extracomunitario_type', 'feature_gasto_iva_parcial',
      'feature_iva_deducible_parcialmente', 'feature_document_projects',
    ],'userData.available_features.')),
    ...mapFields('documents', ['areIvaChecksChanged', 'supplierdbListHeadersUser']),
    autocompleteCountryItems: function() {
      return this.getCountries.map((country_code) => {
        let country = this.getCountryByCode(country_code);
        return {"text": country.name, "value": country.code}
      });
    },
    show_select_all() {
      let show = false;
      let length_selected = this.selected.length;
      let items_lenth = this.items.length
      if (items_lenth == length_selected) {
        if (['export'].includes(this.selected_action)) {
          show = true;
        }
      }
      return show;
    },

    getActions() {
      let actions = {};
      for (let i in this.actions) {
        let group = this.actions[i]['group'];
        if (!actions.hasOwnProperty(group)) {
          actions[group] = [];
        }
        if (!this.actions[i].hasOwnProperty('permission') || !this.got_feature('feature_not_create_thirds_and_masters')) {
          actions[group].push(this.actions[i]);
        }
      }
      Object.keys(actions).forEach(function(key) {
        if (actions[key].length == 0) {
          delete actions[key];
        }
      });
      return actions;
    },
  },

  created() {
    this.actualScreen = 'supplierListValues';
    this.downloadJobState = 'done';
    this.asyncJobId = 0;
    this.getCountriesList();
    this.cancelMassiveChanges();
  },

  methods: {
    ...mapActions(["setSupplierRowsPerPage"]),
    ...mapActions({ 
      refreshData: "refreshData",
      generateFilters: "cru/generateFilters",
      cleanFilters: "cru/cleanFilters",
      exportCru: "cru/exportCru",
      massiveUpdate: "cru/massiveUpdateObject",
      getCountriesList: "countries/getCountries",

      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal',
    }),
    selectRow(data) {
      //this.$store.dispatch('configuration/setForceRightBar',true);
      var params = { name: this.update, params: { 'companydb_id': this.companydb_id, 'supplier': data.id } };
      this.$router.push(params);
    },
    setRowsNumber(rowsNumber) {
      this.setSupplierRowsPerPage(rowsNumber)
    },

    backToDocuments() {
      this.$router.push({ name: 'document-list', params: { companydb_id: this.currentCompany.id } });
    },

    genFilters() {
      this.generateFilters().then(() => {
        this.page = 1;
        this.refresh();
      });
    },
    cleFilters() {
      this.cleanFilters().then(() => {
        this.page = 1;
        this.refresh();
      });
    },
    refresh() {
      this.selected = [];
      this.refreshData(this.currentFilters);
    },

    showMessage(m, icon){
      const modal = {
        text: m,        
        actionConfirmButton: this.closeMessageModal,
      }

      if (icon) {
        modal.icon = icon
      }

      this.setMessageModal(modal)
    },
    doAction() {
      this.ids = [];
      for (let i in this.selected) {
        this.ids.push(this.selected[i].id)
      }
      if (this.selected_action == 'export') {
        this.exportCru({ url: 'export_suppliers/', ids: this.ids, send_filters: this.send_filters, currentCompany: this.currentCompany }).then(response=>{
            this.asyncJobId = response.data['AsyncJob'];
            this.documentName = "proveedores";
            this.documentFormat = "xlsx";
            this.downloadJobState = "running";
        }).catch(err=>{
          this.showMessage('Algo ha ido mal.')
          console.error(err)
        });      
      } else if (this.selected_action == 'delete') {
        this.setMessageModal({
          text: 'Se borraran los proveedores seleccionados.',
          
          showQuestion: true,
          textQuestion: '¿Está seguro?',

          textConfirmButton: 'Sí',
          actionConfirmButton: () => { this.deleteItems(false) },
        
          showCancelButton: true,
          textCancelButton: 'No',
          actionCancelButton: this.noDeleteItems
        })
      } else if (this.selected_action == 'massive_change') {
        this.massiveDialog = true;
      } else {
        console.debug('Not Implemented');
      }
    },
    async jobDone() {
      if (this.selected_action == 'export') {
        const response = await jobs.getJobFile({ id: this.asyncJobId });
        let fileURL = response.data.url;
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", this.documentName + "." + this.documentFormat);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
    },
    selectedAction(actionId) {
      this.selected_action = actionId;
      this.doAction();
    },
    deleteItems(force) {
      this.closeMessageModal()
      this.loadingAction = true;
      this.exportCru({ url: 'delete_suppliers/', ids: this.ids, force: force }).then(response=>{
        this.loadingAction = false;
        
        let errs = response.data['errors'];
        let can_force = response.data['can_force'];
        let isHtml = false;
        let msg = '';
        let icon;
        if (errs.length) {
          for (let i in errs) {
            msg = msg + errs[i] + '<br/>';
          }
          isHtml = true;
        } else {
          msg = 'Proveedores borrados con éxito.';
          icon = 'mdi-information-outline'
        }
        if (can_force) {
          this.setMessageModal({
            text: msg,
            isHtml: isHtml,
            textConfirmButton: 'Sí',
            actionConfirmButton: this.forceDelete,

            showCancelButton: true,
            textCancelButton: 'No',
            actionCancelButton: this.noForceDelete
          })

        } else {
          this.selected = [];
          this.setMessageModal({
            isHtml: isHtml,
            text: msg,
            textConfirmButton: 'Aceptar',
            actionConfirmButton: this.closeMessageModal,
            icon: icon,
          })
        }

        this.refresh();
      }).catch(err=>{
        this.showMessage('Algo ha ido mal.')
        this.loadingAction = false;
        console.error(err);
      });
    },
    noDeleteItems() {
      this.selected = [];
      this.closeMessageModal()
    },
    noForceDelete() {
      this.closeMessageModal()
      this.noDeleteItems();
    },
    forceDelete() {
      this.closeMessageModal()
      this.deleteItems(true);
    },

    showMassiveChangeSuplidoAccount() {
      if (this.got_feature('feature_suplido_account') && this.currentCompany && this.currentCompany.configuration && this.currentCompany.companydb_type.params) {
        return !this.currentCompany.companydb_type.params.hasOwnProperty('hide') || (this.currentCompany.companydb_type.params.hide && !this.currentCompany.companydb_type.params.hide.includes('suplido_account'));
      }
      return false;
    },

    cancelMassiveChanges() {
      this.massiveDialog = false;
      this.cru_errors_supplierScreenValues = {};

      this.cru_expens_accounts = '';
      this.cru_retention_type = '';
      this.cru_inversion_sujeto_pasivo_iva_percent = '';
      this.cru_inversion_sujeto_pasivo_igic_percent = '';
      this.cru_intracomunitario_percent = '';
      this.cru_intracomunitario_type = '';
      this.cru_importaciones_percent = '';
      this.cru_is_comerciante_minorista_percent = '';
      this.cru_zip_code = '';
      this.cru_default_actividad = '';
      this.cru_default_project = '';
      this.cru_default_channel = null;
      this.cru_default_section = null;
      this.cru_default_delegation = null;
      this.cru_default_department = null;
      this.cru_city = '';
      this.cru_province = '';
      this.cru_country = '';
      this.cru_notes = '';
      this.cru_review = false;
      this.cru_automatic_payment_account = '';
      this.cru_payment_account = '';
      this.cru_suplido_account = '';
      this.selectedIvaCheck = undefined;
      this.selectedFiscal = undefined;
      this.selectedCriterioCaja = undefined;
      this.selectedProrate = undefined;
      this.selectedIsComercianteMinorista = undefined;
      this.cru_type = '';

      let keys = Object.keys(this.isEnabled);
      for (let i in keys) {
        this.isEnabled[keys[i]] = false;
      } 
    },


    doMassiveChanges() {
      this.loadingAction = true;
      let params = {};
      if (this.isEnabled.expens_accounts) {
        params['expens_accounts'] = this.cru_expens_accounts;
      }
      if (this.isEnabled.retention_type) {
        params['retention_type'] = this.cru_retention_type;
      }
      if (this.isEnabled.types) {
        params['inversion_sujeto_pasivo_iva'] = false;
        params['inversion_sujeto_pasivo_igic'] = false;
        params['intracomunitario'] = false;
        params['extracomunitario'] = false;
        params['no_sujeta'] = false;
        params['dry_0_percent'] = false;

        if (this.selectedFiscal){
          params[this.selectedFiscal] = true;
        }
        if (this.selectedFiscal === 'inversion_sujeto_pasivo_iva' && this.cru_inversion_sujeto_pasivo_iva_percent) {
          params['inversion_sujeto_pasivo_iva_percent'] = this.cru_inversion_sujeto_pasivo_iva_percent;
        }
        if (this.selectedFiscal === 'inversion_sujeto_pasivo_igic' && this.cru_inversion_sujeto_pasivo_igic_percent) {
          params['inversion_sujeto_pasivo_igic_percent'] = this.cru_inversion_sujeto_pasivo_igic_percent;
        }
        if (this.selectedFiscal === 'intracomunitario') {
          if (this.cru_intracomunitario_percent) {
            params['intracomunitario_percent'] = this.cru_intracomunitario_percent;
          }
          if (this.cru_intracomunitario_type) {
            params['intracomunitario_type'] = this.cru_intracomunitario_type;
          }
        }
        if (this.selectedFiscal === 'extracomunitario') {
          params['importaciones_percent'] = this.cru_importaciones_percent;
        }
        if (this.selectedFiscal == 'is_comerciante_minorista') {
          params['is_comerciante_minorista_percent'] = this.cru_is_comerciante_minorista_percent;
        }
      }
      if (this.isEnabled.are_deducible) {
        let checks_iva_fields = ['iva_igic_no_deducible', 'gasto_iva_parcial', 'iva_parcial']
        checks_iva_fields.forEach((field)  => {
          let value = false;
          if (this.selectedIvaCheck == field) {
            value = true;
          }
          params[field] = value;
        });
        if (this.selectedIvaCheck === 'iva_igic_no_deducible') {
          params['register_iva_igic_0'] = this.cru_register_iva_igic_0;
        }
        
        if (params['gasto_iva_parcial']) {
          if (this.cru_gasto_iva_percent <= 100 && this.cru_gasto_iva_percent >= 0) {
            params['gasto_iva_percent'] = this.cru_gasto_iva_percent;
          }
        }
        if (params['iva_parcial']) {
          if (this.cru_gasto_iva_percent <= 100 && this.cru_gasto_iva_percent >= 0) {
            params['gasto_iva_percent'] = this.cru_gasto_iva_percent;
          }
          params['exc_expense_account'] = this.cru_exc_expense_account;
        }
      }
      if (this.isEnabled.default_actividad) {
        params['default_actividad'] = this.cru_default_actividad;
      }
      if (this.isEnabled.default_project) {
        params['default_project'] = this.cru_default_project;
      }
      if (this.isEnabled.default_channel) {
        params['default_channel'] = this.cru_default_channel;
      }
      if (this.isEnabled.default_section) {
        params['default_section'] = this.cru_default_section;
      }
      if (this.isEnabled.default_delegation) {
        params['default_delegation'] = this.cru_default_delegation;
      }
      if (this.isEnabled.default_department) {
        params['default_department'] = this.cru_default_department;
      }
      if (this.isEnabled.zip_code) {
        params['zip_code'] = this.cru_zip_code;
      }
      if (this.isEnabled.city) {
        params['city'] = this.cru_city;
      }
      if (this.isEnabled.province) {
        params['province'] = this.cru_province;
      }
      if (this.isEnabled.country) {
        params['country'] = this.cru_country;
      }
      if (this.isEnabled.notes) {
        params['notes'] = this.cru_notes;
      }
      if (this.isEnabled.review) {
        params['review'] = this.cru_review;
      }
      if (this.isEnabled.prorate) {
        params['prorate'] = !!this.selectedProrate;
      }
      if (this.isEnabled.criterio_de_caja) {
        params['criterio_de_caja'] = !!this.selectedCriterioCaja;
      }
      if (this.isEnabled.is_comerciante_minorista) {
        params['is_comerciante_minorista'] = !!this.selectedIsComercianteMinorista;
      }

      if (this.isEnabled.automatic_payment_account) {
        params['automatic_payment_account'] = this.cru_automatic_payment_account;
      }
      if (this.isEnabled.payment_account) {
        params['payment_account'] = this.cru_payment_account;
      }
      if (this.isEnabled.suplido_account) {
        params['suplido_account'] = this.cru_suplido_account;
      }
      if (this.isEnabled.type) {
        params['type'] = this.cru_type;
      }
      this.massiveUpdate({ 
        'url': 'massive_update_supplierdb/', 
        'ids': this.ids,
        'params': params, 
        'currentCompany': this.currentCompany
      }).then(res => {
        if ('error' in res.data) {
          this.showMessage(res.data['error']);
        }
        else {
          this.cancelMassiveChanges();
          this.showMessage('Cambios realizados con éxito.', 'mdi-information-outline')
          this.refreshData(this.currentFilters);
        }
        this.loadingAction = false;
      }).catch(err => {
        console.error(err);
        this.showMessage('Algo ha ido mal.')
        this.loadingAction = false;
      });
  
    },

    toggleFiscal(){

      if (this.selectedFiscal === this.lastSelectedFiscal) {
        this.selectedFiscal = undefined;
      }
    },
    toggleCriterioCaja(){
      if (this.selectedCriterioCaja == this.lastSelectedCriterioCaja) {
        this.selectedCriterioCaja = undefined
      }
    },
    toggleProrate(){
      if (this.selectedProrate === this.lastSelectedProrate) {
        this.selectedProrate = undefined
      }
    },
    toggleIsComercianteMinorista() {
      if (this.selectedIsComercianteMinorista == this.lastSelectedIsComercianteMinorista) {
        this.selectedIsComercianteMinorista = undefined;
      }
    },

    toggleIvaCheck() {
      if (this.selectedIvaCheck === this.lastSelectedIvaCheck) {
        this.selectedIvaCheck = undefined;
      }
      this.cru_gasto_iva_percent = 50;
      this.cru_exc_expense_account = '';
      this.lastSelectedIvaCheck = this.selectedIvaCheck
    },
    hasMasterPermission(master) {
      return this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && 
      this.currentCompany.companydb_type.params.show.includes(master);
    }
  },
  watch: {
    selectedFiscal() {
      setTimeout(() => {
        this.lastSelectedFiscal = this.selectedFiscal;
      })
    },
    selectedCriterioCaja() {
      setTimeout(() => {
        this.lastSelectedCriterioCaja = this.selectedCriterioCaja;
      })
    },
    selectedProrate() {
      setTimeout(() => {
        this.lastSelectedProrate = this.selectedProrate;
      })
    },
    selectedIsComercianteMinorista() {
      setTimeout(() => {
        this.lastSelectedIsComercianteMinorista = this.selectedIsComercianteMinorista;
      });
    }
  },
};
</script>

<style lang="scss" scoped>  
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
</style>


<!-- Mobile SupplierList -->
<style>
.supplier-list--mobile {
  overflow-y: hidden !important;

  padding: 0 !important;

  .v-card__title {
    padding: 0 !important;

    .row {
      margin: 0 !important;

      .v-toolbar__content{
        padding: 0 !important;

        .v-application .mr-2 {
          margin-right: 16px !important;
        }
      }
    }

    .col{
      padding: 0 !important;
    }

    .flex-grow-1.col {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-left: 8px !important;
    }
  }

  thead > tr > th{
      border: 1px solid #ccc;
      border-radius: 0 !important;
  }

  .container {
      padding: 0 !important;
  }

  .app-col--no-input-fields-above{
      padding: 0 !important;
  }

  .v-data-table__wrapper {
    min-height: calc(100vh - 220px); 
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    margin-bottom: 2px !important;
    border-radius: 0 !important;

    table {
      tbody > tr {
        td:first-child {
          background-color: #5C3D8F !important;

          .theme--light.v-icon{
            color: white !important;
          }
        }
        td {
          border: 1px solid gray;
        }
      }
    }
  }

  .v-data-footer{
    margin: 0 !important;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    min-height: 80px;

    .v-data-footer__select{
      margin: 0 !important;
      display: none !important;
    }
  }

  .v-card__text{
    padding: 0 !important;
  }

  .v-data-table-header-mobile__wrapper{
    width: fit-content;
    min-height: 8vh
  }

  .v-text-field{
    padding-top: 0 !important; 
    margin-top: 0 !important;
  }

  .v-input{
    margin-top:16px !important;
  }
}
</style>
